export default __webpack_public_path__ + "static/media/doctorss.04346134.PNG";